exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.rule-content p{font-size:.7rem;color:#7F8490;line-height:2\n}\n", "", {"version":3,"sources":["D:/TsWeb/h5aliex/src/view/task.vue"],"names":[],"mappings":";AAAA,gBAAgB,gBAAgB,cAAc,aAAa;CAAC","file":"task.vue","sourcesContent":[".rule-content p{font-size:.7rem;color:#7F8490;line-height:2}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6adaa0b4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/task.vue
// module id = nwvr
// module chunks = 0